<template>
  <div class="index">
    <!---------- 待审核人数 ---------->
    <!-- 当前时间未到审核截止时间 && 有审核人数 ==> 显示 -->
    <el-alert v-show="isShowGoAudit && parseInt(awaitNum) > 0" title="" type="warning">
      <div class="importantNote">
        <i class="iconfont icon-kaiqi f16 col_FEAF0D mr5"></i>
        <span>您有<span class="col_orange">&nbsp;&nbsp;{{ awaitNum }}&nbsp;&nbsp;</span>报名信息待审核，<span @click="handleClick" class="col_blue cp">去审核</span></span>
      </div>
    </el-alert>

    <!-- 选择批次 -->
    <div class="chosePlan">
      <p>
        <span class="routerName">首页</span>
        <span class="split">/</span>
        <span class="planName">{{ currentPlan.name }}</span>
        <el-dropdown trigger="click" style="margin-left: 8px;">
          <span class="el-dropdown-link">
            <img :src="planImg" alt=""/>
          </span>
          <template #dropdown>
            <el-dropdown-menu style="max-width: 400px; max-height:480px; height:auto; overflow-y:auto;">
              <el-dropdown-item v-for="(item, index) in planList" :key="index" @click.native="changPlan(item)">{{ item.name }}</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </p>
    </div>

    <!-- 卡片 -->
    <div class="titleCard">
      <!-- 报名卡 -->
      <div :class="cardClass">
        <div>
          <div>
            <h3>
              <span>移动</span><span>/</span><span>PC</span><span>报名人数</span>
              <h2>{{ cardInfo.signNum }}</h2>
            </h3>
            <div style="display: flex;">
              <span>{{ cardInfo.mobileSignNum }}</span><span class="examNumCard">|</span><span>{{ cardInfo.webSignNum }}</span>
            </div>
            <div class="time">
              <p> 报名时间：<span>{{ planInfo.beginSign }}</span>&nbsp;至&nbsp;<span>{{ planInfo.endSign }}</span></p>
            </div>
          </div>
          <div class="icon"></div>
        </div>
      </div>
      <!-- 审核卡 -->
      <div :class="cardClass">
        <div>
          <div>
            <h3>审核通过人数</h3>
            <span>{{ cardInfo.passNum }}</span>
            <div class="time">
              <p v-if="planInfo.needAudit == 2"> 初审截止时间：<span>{{ planInfo.primaryEndAudit }}</span></p>
              <p v-if="planInfo.needAudit !== 0"> {{ planInfo.needAudit == 2 ? "终审截止时间：" : "审核截止时间：" }}<span>{{ planInfo.endAudit }}</span></p>
            </div>
          </div>
          <div class="icon"></div>
        </div>
      </div>
      <!-- 缴费卡 -->
      <div :class="cardClass" v-show="planInfo.isPay == 1">
        <div>
          <div>
            <h3>已缴费人数</h3>
            <span>{{ cardInfo.payNum }}</span>
            <div class="time">
              <p>缴费时间：<span>{{ planInfo.startPay }}</span>&nbsp;至&nbsp;<span>{{ planInfo.endPay }}</span></p>
            </div>
          </div>
          <div class="icon"></div>
        </div>
      </div>
      <!-- 考试卡 -->
      <div :class="cardClass">
        <div>
          <div>
            <h3>
              <span>参加考试人数</span><span>/</span><span>人次</span>
            </h3>
            <div style="display: flex;">
              <span>{{ cardInfo.examNum }}</span><span class="examNumCard">|</span><span>{{ cardInfo.examCourseNum }}</span>
            </div>
            <div class="time">
              <p>考试时间：<span>{{ planInfo.beginExam }}</span>&nbsp;至&nbsp;<span>{{ planInfo.endExam }}</span></p>
            </div>
          </div>
          <div class="icon"></div>
        </div>
      </div>
    </div>

    <div class="bottom">
      <!-------- 院校公告 -------->
      <div class="pr" :style="planInfo.isPay == 1 ? '' : NoticeStyle">
        <h1>院校公告</h1>
        <div class="content">
          <div class="sign-bottom" v-if="noticeInfo.length">
            <!-- 公告滚动 -->
            <div class="sign-bottom-main" @click="handleClickNotice($event)">
              <!-- vue 滚动组件 -->
              <vueSeamlessScroll
                v-if="noticeInfo.length"
                :data="noticeInfo"
                class="wrap"
              >
                <ul>
                  <li v-for="(item, index) in noticeInfo" :key="index">
                    <div
                      :class="[
                        item.isRead == 'true' ? 'is_notice' : '',
                        'noticeBorder',
                      ]"
                    >
                      <a
                        href="javascript:void(0);"
                        @click="Notice(item.id)"
                        :data-id="item.id"
                        >{{ item.title }}</a
                      >
                      <div class="noticeHover">{{ item.title }}</div>
                    </div>
                    <span class="sign-bottom-main-data">{{
                      item.releaseTime
                    }}</span>
                  </li>
                </ul>
              </vueSeamlessScroll>
            </div>
          </div>
          <span v-else>暂无数据</span>
        </div>
        <!-- 公告提示弹窗 -->
        <ots-custom-dialog
          :dialog.sync="paperDialog"
          title="公告提示"
          width="60%"
        >
          <template v-slot:content>
            <h1 style="text-align:center;">{{ alertInfo.title }}</h1>
            <p
              v-html="alertInfo.content"
              style="text-indent:2rem;margin-top:16px;"
              class="returnP"
            ></p>
          </template>
        </ots-custom-dialog>
      </div>

      <!------- 实时缴费 ------->
      <div class="pr" v-if="planInfo.isPay == 1">
        <h1>实时缴费</h1>
        <!-- 缴费人数 -- 缴费总额 -->
        <span v-if="payStudentList.length" class="payTips"
          >已成功缴费<span class="col_00A652"> {{ payNum }} </span>人，共缴费
          <span class="col_00A652">¥ {{ total }}</span> 元</span
        >
        <div class="content">
          <!-- vue 滚动组件 -->
          <vueSeamlessScroll
            v-if="payStudentList.length"
            :data="payStudentList"
            class="wrap"
          >
            <ul class="payStudent">
              <li
                v-for="item in payStudentList"
                :key="item.photo + Math.random(0, 1)"
              >
                <div class="user">
                  <img :src="item.photo" alt="" class="userImg" />
                  <span>{{ item.realName }}</span>
                </div>
                <div class="col_grayZ">{{ item.payDate }}</div>
                <div class="col_00A652 payStatus">缴费成功</div>
              </li>
            </ul>
          </vueSeamlessScroll>
          <span v-else>暂无数据</span>
        </div>
      </div>

      <!------- 成绩分布 style="width: calc(100% - 420px)" ------->
      <div class="pr" style="width: 100%">
        <h1>成绩分布</h1>
        <div class="courseLine">
          <ul>
            <!-- 横向: 课程列表 -->
            <li
              v-for="item in courseListBefore"
              :key="item.courseId"
              :class="item.courseId == currentCourseId ? 'current' : ''"
              class="cp"
              @click="changeCourse(item)"
            >
              {{ item.courseName }}
            </li>
            <!-- 课程数量 > 4 ==> 展示课程下拉列表 -->
            <el-dropdown
              @command="changeCourse"
              trigger="click"
              v-if="courseList.length > 4"
            >
              <span class="el-dropdown-link" style="cursor: pointer;"
                >·&nbsp;·&nbsp;·&nbsp;</span
              >
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in courseListAfter"
                  :key="item.courseId"
                  :command="courseListAfter[index]"
                  >{{ item.courseName }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </ul>
        </div>
        <!-- E-charts -->
        <div class="content achievement" style="width:100%;">
          <div v-show="isDraw" id="myChart" class="drawArea"></div>
          <span v-if="!isDraw">暂无数据</span>
        </div>
      </div>

      <!-- 二维码 style="width: 400px;" -->
      <div class="pr" v-if="false">
        <h1>学员登录二维码</h1>
        <div class="content achievement">
          <div class="QRCode">
            <img :src="QRCode" alt="" id="QRCode" />
            <p class="QRLogin">微信扫描二维码登录学员移动平台</p>
            <div class="RQbtn">
              <div>
                <img :src="downloadImg" alt="" />
                <span @click="copyIns">复制链接</span>
              </div>
              <div>|</div>
              <div>
                <img :src="copyImg" alt="" />
                <span @click="downLoadQR">下载图片</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import isHasRoute from "@/help/isHasRoute";
import {
  getSignNumberFn,
  getRealTimePayFn,
  scoreData,
  getCodeImg,
} from "@/http/modules/home";
import { mapMutations } from "vuex";
import {
  selectNoticeByIdInfo,
  selectNoticeListInfo,
} from "@/http/modules/student/notice";
import {
  getSelectPlanFn,
  getCurrentPlanFn,
  getPagePlan,
} from "@/http/modules/examSet/examBatch";
export default {
  name: "index",
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      cardInfo: {},




      /* ** 是否显示 "去审核 Alert 提示窗口" ** */
      isShowGoAudit: true,
      /* ** E-charts(成绩分布)是否有数据 ** */
      isDraw: true,
      /* ** 待审核人数 ** */
      awaitNum: 0,
      /* ** web端 报名人数 ** */
      webSignNum: 0,
      /* ** 移动端 报名人数 ** */
      mobileSignNum: 0,
      /* ** 考试人数 ** */
      examNum: 0,
      /* ** 考试通过人数 ** */
      passNum: 0,
      /* *** 考试人次 *** */
      examCourseNum: 0,
      /* ** 已缴费人数 ** */
      payNum: 0,
      /* ** 报名人数 ** */
      signNum: 0,
      /* ** 实时缴费滚动列表 ** */
      payStudentList: [],
      /* ** 成绩分布 -- 所有课程 ** */
      courseList: [],
      /* ** 成绩分布 -- 前四条课程 ** */
      courseListBefore: [],
      /* ** 成绩分布 -- 删除前四条之后的课程 ** */
      courseListAfter: [],
      /* ** 成绩分布 -- 选中课程 ** */
      currentCourseId: "",
      /* ** 当前考试批次所有数据 ** */
      planInfo: "",
      /* ** 获取主页的公告列表 ** */
      noticeInfo: "",
      /* ** 缴费总额 ** */
      total: "",
      /* ** 弹窗数据 ** */
      alertInfo: {},
      /* ** 公告展示弹出层 ** */
      paperDialog: false,
      /* ** 二维码 ** */
      QRCode: "",
      /* ** 二维码链接 ** */
      QRCodeIns: "",
      /* ** 二维码 -- 下载图片引入 ** */
      downloadImg: require("@/assets/img/index_download.png"),
      /* ** 二维码 -- 复制图片引入 ** */
      copyImg: require("@/assets/img/index_ins.png"),
      /* ** 院校公告样式(根据是否有"实时缴费"切换) ** */
      NoticeStyle: { width: "100%" },
      planList: [],
      currentPlan: "",
      requestForm: {
        planId: "",
      },
      planImg: require("@/assets/img/courseChange.png"),
    };
  },
  computed: {
    /**
     * @param { 卡片 class 名 }
     */
    cardClass() {
      return `titleCardItem ${this.planInfo.isPay == 1 ? "titleCardItemWidth_25" : "titleCardItemWidth_33"}`;
    },



    /* ** 获取菜单展示路由 ** */
    routes() {
      return this.$store.getters.showRoutes;
    },
  },
  watch: {
    /* ** 切换 -- 成绩分布课程 -- 获取图表数据 ** */
    currentCourseId: "getScoreData",
  },
  created() {
    /* ** 获取 -- 二维码 ** */
    //this.getQRCode();
  },
  mounted() {
    /* ** 获取 -- 自动弹出公告数据 ** */
    this.getAlertNotice();
    this.initData();
  },
  methods: {
    ...mapMutations("currentPlan", ["setCurrentPlan"]),

    /**
     * @param { 批次列表 }
     */
    async initData() {
      const { data } = await getPagePlan({publish: 1});
      this.planList = data;
      this.currentPlan = data[0];
      this.requestForm.planId = data[0].id;
      this.getData();
    },

    /**
     * @param { 切换批次 }
     */
    changPlan(value) {
      this.currentPlan = value;
      this.requestForm.planId = value.id;
      this.getData();
    },
    /**
     * @param { (1) 获取卡片数据 }
     */
    async initNumbers() {
      let { planId } = this.requestForm;
      const { data } = await getSignNumberFn({ planId });

      for(let Key in data) {
        data[Key] = data[Key] ? data[Key] : 0;
      }
      this.cardInfo = { ...data };


      console.log("cardInfo", this.cardInfo);

      if (data) {
        this.awaitNum = data.awaitNum ? data.awaitNum : 0;
        this.examNum = data.examNum ? data.examNum : 0;
        this.passNum = data.passNum ? data.passNum : 0;
        this.payNum = data.payNum ? data.payNum : 0;
        this.signNum = data.signNum ? data.signNum : 0;
        this.examCourseNum = data.examCourseNum;
        this.webSignNum = data.webSignNum ? data.webSignNum : 0;
        this.mobileSignNum = data.mobileSignNum ? data.mobileSignNum : 0;
      }

    },

    /**
     * @param { 根据批次获取相关数据 }
     */
    getData() {
      // 卡片数据
      /* ** 获取 -- 缴费总额 ** */
      this.getTotal();
      /* ** 获取 -- 成绩分布数据 ** */
      this.getCourse();
      /* ** 获取 -- 当前批次 -- 报名,审核,缴费等人数 ** */
      this.initNumbers();

      /* ** 获取 -- 实时缴费数据 ** */
      this.getPayStudent();
      this.getScoreData();
      /* ** 获取 -- 院校公告列表 ** */
      this.getNotice();
    },

    /********************************
     * @this 获取院校二维码
     *******************************/
    getQRCode() {
      getCodeImg().then((res) => {
        // (1) 二维码图片文件
        this.QRCode = res.data.base64Img;
        // (2) 二维码下载链接
        this.QRCodeIns = res.data.officialH5Url;
        // (3) 获取二维码DOM
        let QRIMG = document.getElementById("QRCode");
        // (4) 二维码DOM添加SRC属性
        QRIMG.setAttribute("src", res.data.base64Img);
      });
    },

    /*******************************
     * @copyIns 获取院校二维码链接
     ******************************/
    copyIns() {
      // (1) 生成 input 并配置 value
      let createInput = document.createElement("input");
      // (2) input.value 赋值 ( 想要复制的值 )
      createInput.value = this.QRCodeIns;
      // (3) input DOM 添加
      document.body.appendChild(createInput);
      // (4) 选择该 input 对象
      createInput.select();
      // (5) 调用浏览器复制方法
      document.execCommand("Copy");
      // (6) 隐藏添加的 input DOM
      createInput.style.display = "none";
      // (7) 复制成功提示
      this.$message.success("二维码链接复制成功！");
    },

    /*******************************
     * @downLoadQR 获取院校二维码链接
     ******************************/
    downLoadQR() {
      // (1) 生成 <a> 链接
      let alink = document.createElement("a");
      // (2) 配置 href 值
      alink.href = this.QRCode;
      // (3) 配置文件名
      alink.download = "学员登录二维码";
      // (4) 下载
      alink.click();
    },

    /**********************************
     * @this 获取当前批次已缴费总额
     **********************************/
    getTotal() {
      // (1) 查询当前批次信息
      getCurrentPlanFn({
        planId: this.requestForm.planId,
      })
        .then((res) => {
          res = res.data;
          if (res.endAudit) {
            let currentTime = new Date().getTime();
            let endAuditTime = new Date(res.endAudit).getTime();
            this.isShowGoAudit = currentTime > endAuditTime ? false : true;
          } else {
            this.isShowGoAudit = false;
          }
          // (2) 查询当前批次缴费总额
          return this.$api.applyManage.getBillManageTotal({
            state: "1,2",
            planId: res.id,
          });
        })
        .then((res) => {
          if (res.code == 1) {
            this.total = res.data;
          }
        });
    },

    /**********************************
     * @this 加载页面展示公告列表
     **********************************/
    getNotice() {
      // (1) 公告列表( 不包含"自动弹出公告" )
      selectNoticeListInfo({
        isFrom: "00",
        planId: this.requestForm.planId,
      }).then((res) => {
        if (res.code == 1) {
          this.noticeInfo = res.data;
        }
      });
    },

    /**********************************
     * @this 点击弹窗数据
     **********************************/
    Notice(e) {
      // (1) 单击公告( 获取单条公告数据 )
      selectNoticeByIdInfo({
        id: e,
        isFrom: "00",
        planId: this.requestForm.planId,
      }).then(({ data }) => {
        if (data) {
          this.paperDialog = true;
          this.alertInfo = data;
        }
        this.getNotice();
      });
    },

    /*********************************
     * @this 自动弹窗数据(弹出单条公告)
     *********************************/
    async getAlertNotice() {
      this.alertInfo = [];
      let params = { isFrom: "01" };
      // (1) 查询 -- 弹出公告
      const { data } = await selectNoticeListInfo(params);
      if (data.length > 0 && data[0].noticeShow != "0") {
        this.paperDialog = true;
        this.alertInfo = data[0];
        let par = { id: data[0].id, isFrom: "00" };
        // (2) 标记已读公告;
        selectNoticeByIdInfo(par);
        // (3) 更新已读状态
        this.getNotice();
      } else {
        this.paperDialog = false;
      }
    },

    /**********************************
     * @this 修改课程标签
     **********************************/
    changeCourse(obj) {
      this.currentCourseId = obj.courseId;
    },

    /**********************************
     * @this 判断是否显示--E-charts--柱状图
     **********************************/
    async getScoreData() {
      const { data } = await scoreData({
        courseId: this.currentCourseId,
        planId: this.requestForm.planId,
      });
      if (data) {
        this.isDraw = true;
        this.drawLine(data);
      } else {
        this.isDraw = false;
      }
    },

    /**********************************
     * @this E-charts--图表绘制
     **********************************/
    drawLine(data) {
      // (1) 基于准备好的Dom，初始化E-charts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      let option = {};
      // (2) 配置 E-charts 数据
      if (data.type == "pie") {
        option = {
          title: {},
          tooltip: {
            trigger: "item",
          },
          series: [
            {
              type: "pie",
              radius: "50%",
              data: data.result,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
      } else {
        let xData = data.result.map((item) => item.name);
        let yData = data.result.map((item) => item.value);
        option = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "line",
              lineStyle: {
                color: {
                  type: "line",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#7EA1E6 ",
                    },
                    {
                      offset: 1,
                      color: "#7EA1E6 ",
                    },
                  ],
                },
                opacity: 0.1,
                type: "solid",
                width: 60,
              },
            },
            formatter: function(param) {
              let firstParams = param[0];
              return (
                "区间：" +
                firstParams.name +
                "分" +
                "<br>" +
                "人数：" +
                firstParams.value +
                "人"
              );
            },
          },
          grid: {
            left: "0%",
            right: "0%",
            bottom: "2%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            data: xData,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#DADDE6",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#737780",
            },
          },
          yAxis: {
            name: "人",
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#DADDE6",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#737780",
            },
            nameTextStyle: {
              color: "#9299A6",
              align: "right",
            },
          },
          series: [
            {
              data: yData,
              barWidth: "30px",
              type: "bar",
              itemStyle: {
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: "#12BFB1" },
                  { offset: 0, color: "#36D995" },
                ]),
              },
            },
          ],
        };
      }
      // (3) 绘制图表
      myChart.setOption(option, true);
    },

    /********************************
     * @this 获取主页展示信息(成绩分布)
     ********************************/
    getCourse() {
      // (1) 当前批次信息
      this.$api.applyManage
        .getCurrentPlan({
          planId: this.requestForm.planId,
        })
        .then((res) => {
          this.planInfo = res.data ? res.data : [];
          this.setCurrentPlan(res.data);
          return res;
        })
        .then((res) => {
          // (2) 获取当前批次课程列表
          return this.$api.applyManage.getPlanCourse({ planId: res.data.id });
        })
        .then((res) => {
          if (res.code && res.data.length > 0) {
            this.courseList = res.data;
            this.courseListBefore =
              res.data.length > 4 ? res.data.slice(0, 4) : res.data;
            this.courseListAfter =
              res.data.length > 4
                ? res.data.filter((item, num) => num > 3)
                : [];
            this.currentCourseId = this.courseList[0].courseId;
          }
        });
    },

    /********************************
     * @this 获取展示栏人数
     ********************************/
    // async initNumbers() {
    //   const { data } = await getSignNumberFn({
    //     planId: this.requestForm.planId,
    //   });
    //   if (data) {
    //     this.awaitNum = data.awaitNum ? data.awaitNum : 0;
    //     this.examNum = data.examNum ? data.examNum : 0;
    //     this.passNum = data.passNum ? data.passNum : 0;
    //     this.payNum = data.payNum ? data.payNum : 0;
    //     this.signNum = data.signNum ? data.signNum : 0;
    //     this.examCourseNum = data.examCourseNum;
    //     this.webSignNum = data.webSignNum ? data.webSignNum : 0;
    //     this.mobileSignNum = data.mobileSignNum ? data.mobileSignNum : 0;
    //   }
    // },

    /****************************
     * @this 获取学生缴费信息
     ****************************/
    async getPayStudent() {
      const { data } = await getRealTimePayFn({
        planId: this.requestForm.planId,
      });
      if (data) {
        this.payStudentList = data.payList;
      }
    },

    /**************************
     * @this 快捷审核
     **************************/
    handleClick() {
      if (isHasRoute("applyAudit", this.routes)) {
        this.$router.push({ name: "applyAudit" });
      } else {
        this.$router.push({ name: "applyFirst" });
      }
    },

    /**************************
     * @this 公告滚动,事件委托
     **************************/
    handleClickNotice(e) {
      let target = e.target;
      if (target.tagName == "A") {
        this.Notice(target.dataset.id);
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 选择批次
.chosePlan {
  margin-bottom: 20px;
  height: 32px;
  p {
    .routerName {
      font-size: 14px;
      color: #9299a6;
    }
    .split {
      margin: 0 8px;
    }
    .planName {
      font-size: 24px;
      font-weight: 500;
      color: #2d2f33;
    }
    .el-dropdown-link {
      cursor: pointer;
      color: var(--el-color-primary);
      display: flex;
      align-items: center;
    }
  }
}
.el-dropdown-menu {
  overflow: scroll;
  max-height: 360px;
  overflow-x: hidden;
  cursor: pointer;
  .el-dropdown-menu__item {
    margin-left: 8px;
  }
}

// .title {
//   height: 32px;
//   p {
//     .routerName {
//       font-size: 14px;
//       color: #9299a6;
//     }
//     .planName {
//       font-size: 24px;
//       font-weight: 500;
//       color: #2d2f33;
//     }
//     .el-dropdown-link {
//       cursor: pointer;
//       color: var(--el-color-primary);
//       display: flex;
//       align-items: center;
//     }
//   }
// }

.returnP {
  width: 100%;
  word-break: break-all;
  word-wrap: break-word;
}
/* *** 上方展示标签 *** */
.index {
  font-family: "PingFangSC-Medium, PingFang SC";
  .el-alert {
    margin-bottom: 24px;
    background: #fff5e0;
    border: 1px solid #ffd970;
    height: 48px;
    line-height: 48px;
    box-sizing: border-box;
    .importantNote {
      font-size: 14px;
      color: #45494d;
      margin-left: -10px;
      margin-top: -7px;
    }
    /deep/ .el-alert__closebtn {
      top: 17px;
      color: #ff9500;
    }
  }
  /* *** 展示标签页小屏样式 *** */
  .titleCard {
    display: flex;
    justify-content: space-between;
    color: #fff;
    .titleCardItem.titleCardItemWidth_25 {
      width: 25%;
    }
    .titleCardItem.titleCardItemWidth_33 {
      width: 33%;
    }
    .titleCardItem {
      max-height: 148px;
      margin-right: 16px;
      background-size: 100% 100%;
      box-shadow: 0px 6px 24px 0px rgba(0, 69, 166, 0.15);
      border-radius: 8px;
      padding: 20px 30px 20px 24px;
      box-sizing: border-box;
      transition: all .5s;
      /* *** 时间提示样式 *** */
      & > div {
        width: 100%;
        height: auto;
        position: relative;
        .icon {
          width: 64px;
          height: 64px;
          right: 0;
          top: 50%;
          position: absolute;
          transform: translateY(-50%);
        }
        h3 {
          font-size: 14px;
          height: 19px;
          margin-bottom: 5px;
          span {
            font-size: 14px;
            margin-right: 4px;
          }
          h2 {
            display: inline-block;
            margin-left: 8px;
          }
        }
        .examNumCard {
          font-size: 20px;
          display: block;
          line-height: 47px;
          margin: 0 16px;
        }
        span {
          font-size: 36px;
        }
        .time {
          p {
            margin-top: 4px;
            font-size: 13px;
            line-height: 16px;
            position: relative;
            z-index: 1;
            span {
              font-size: 13px;
            }
          }
          p:last-of-type {
            margin-top: 8px;
          }
        }
      }
    }
    .titleCardItem:nth-of-type(4) {
      margin-right: 0;
    }
    .titleCardItem:nth-child(1) {
      background-image: url("../assets/img/bg01.png");
      .icon {
        background-image: url("../assets/img/icon-01.png");
      }
    }
    .titleCardItem:nth-child(2) {
      background-image: url("../assets/img/bg02.png");
      .icon {
        background-image: url("../assets/img/icon-02.png");
      }
    }
    .titleCardItem:nth-child(3) {
      background-image: url("../assets/img/bg03.png");
      .icon {
        background-image: url("../assets/img/icon-03.png");
      }
    }
    .titleCardItem:nth-child(4) {
      background-image: url("../assets/img/bg04.png");
      // .icon {
      //   background-image: url("../assets/img/icon-04.png");
      // }
    }
  }

  /* *** 展示标签小屏样式 *** */
  @media screen and (max-width: 1366px) {
    .titleCard {
      flex-wrap: wrap;
      .titleCardItem.titleCardItem.titleCardItemWidth_25,
      .titleCardItem.titleCardItem.titleCardItemWidth_33 {
        width: 49%;
        height: 124px;
        & > div {
          .time {
            display: flex;
            justify-content: space-between;
            p:first-of-type {
              margin-right: 16px;
            }
            p:last-of-type {
              margin-top: 4px;
            }
          }
        }
      }
      .titleCardItem:nth-of-type(4),
      .titleCardItem:nth-of-type(2) {
        margin-right: 0;
      }
      .titleCardItem:nth-of-type(1),
      .titleCardItem:nth-of-type(3) {
        margin-right: 0px;
      }
      .titleCardItem:nth-of-type(3),
      .titleCardItem:nth-of-type(4) {
        margin-top: 20px;
      }
    }
  }

  /* ** 数据标题样式 ** */
  h1 {
    font-size: 20px;
    color: #2d2f33;
    padding: 32px 0 16px 0;
    line-height: 20px;
    & > span {
      color: #b6b9bf;
      font-size: 14px;
      font-weight: 400;
      float: right;
    }
    & > span:hover {
      cursor: pointer;
    }
  }
}








.bottom {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.bottom > div {
  width: calc(50% - 8px);
  .content {
    width: 100%;
    height: 252px;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    /* ** 学员登录二维码 ** */
    .QRCode {
      width: 210px;
      height: 360px;
      padding-top: 40px;
      box-sizing: border-box;

      & > img {
        display: block;
        width: 200px;
        height: 200px;
        margin: 0 auto;
      }

      & > p {
        margin-top: 16px;
        text-align: center;
        color: #9299a6;
      }

      .RQbtn {
        width: 100%;
        height: 20px;
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        & > div {
          display: flex;
          align-items: center;
          color: #45494d;
          img {
            width: 16px;
            height: 16px;
            margin-right: 2px;
            margin-top: 2px;
          }
          span {
            cursor: pointer;
          }
        }
      }
    }
  }
  .content:first-of-type,
  .content:last-of-type {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .achievement {
    height: 360px;
  }
}
.content .wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.payStudent {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

// 实时缴费滚动列表
.payStudent li {
  display: flex;
  justify-content: space-between;
  height: 58px;
  line-height: 58px;
  border-bottom: 1px dashed #f1f2f5;
  .user {
    width: 160px;
    display: flex;
    align-items: center;
    > img {
      width: 40px;
      height: 40px;
      box-shadow: 0px 0px 4px 0px rgba(199, 205, 213, 0.59);
      border-radius: 50%;
    }
    span {
      display: inline-block;
      margin-left: 8px;
    }
  }
  .payStatus {
    position: relative;
  }
  .payStatus::before {
    content: "";
    position: absolute;
    left: -10px;
    top: 27px;
    width: 5px;
    height: 5px;
    background-color: #00a652;
    border-radius: 50%;
  }
}
.payTips {
  position: absolute;
  right: 0;
  top: 39px;
  font-weight: 400;
  color: #737780;
}
.userImg {
  background: url("../assets/img/userBg.png") no-repeat -140px -20px;
  object-fit: cover;
}

// 成绩分布
.courseLine {
  position: absolute;
  right: 0;
  top: 39px;
}
.courseLine ul {
  display: flex;
  font-size: 14px;
  font-weight: 400;
  color: #737780;
  li {
    margin-right: 24px;
  }
  li.current {
    font-size: 15px;
    font-weight: 500;
    color: #45494d;
    position: relative;
  }
  li.current::after {
    content: "";
    width: 16px;
    height: 3px;
    border-radius: 2px;
    background-color: #006aff;
    position: absolute;
    bottom: -4px;
    right: calc(50% - 8px);
  }
}

/* *** E-charts 图表大小 *** */
.drawArea {
  width: 360px;
  height: 360px;
}

/* ***** 院校公告 ***** */
.sign-bottom {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background-color: #fff;
  box-sizing: border-box;
  .sign-bottom-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 18px;
      color: #2d2f33;
      font-weight: 600;
    }
    a {
      text-decoration: none;
      color: #737780;
      font-size: 14px;
    }
  }
  .sign-bottom-main {
    height: 100%;
    ul {
      li {
        font-size: 14px;
        height: 58px;
        border-bottom: 1px #f1f2f5 dotted;
        display: flex;
        justify-content: space-between;

        .noticeBorder {
          width: 75%;
          height: 58px;
          display: flex;
          align-items: center;
          position: relative;

          a {
            display: inline-block;
            color: #45494d;
            line-height: 58px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            max-width: calc(100% - 60px);
          }

          .noticeHover {
            padding: 0 8px;
            width: auto;
            display: none;
          }

          /* ***** 鼠标悬浮显示全部内容 ***** */
          a:hover + .noticeHover {
            display: block;
            position: absolute;
            background-color: #eee;
            border: 1px solid #737780;
            border-radius: 4px;
            bottom: 100%;
            left: 16px;
          }

          span {
            margin-left: 8px;
            display: inline-block;
            cursor: pointer;
          }
        }

        .noticeBorder::before {
          content: "";
          display: inline-block;
          width: 5px;
          height: 5px;
          margin-right: 7px;
          background: #fe5958;
          border-radius: 50%;
        }

        .sign-bottom-main-data {
          color: #737780;
          float: right;
          line-height: 58px;
        }

        .is_notice {
          a {
            color: #9299a6;
          }
          span {
            color: #9299a6;
          }
        }

        .is_notice::before {
          content: "";
          display: inline-block;
          width: 5px;
          height: 5px;
          margin-right: 7px;
          background: #c2c6cc;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
